import { Injectable, Inject } from '@angular/core';
import { APP_CONFIG } from '../app-config.constants';
import { IAppConfig } from '../app-config.interface';
import { HttpClient } from '@angular/common/http';
import { ObjectResponse } from '../classes/object-response';
import { Agent } from '../classes/agent';
import { environment } from '../../environments/environment-wrapper';
import { MortageRateCategory, MortgageRateSubCategory, MortgageRate } from '../classes/mortgage-rate';
import { PaymentsFrequency } from '../classes/enums';
import { map } from 'rxjs/operators';

@Injectable()
export class MortgageService {
  private _rates: MortageRateCategory[];

  constructor(@Inject(APP_CONFIG) private appConfig: IAppConfig, private http: HttpClient) { }
  async getRates() {

    if (this._rates) return new Promise((resolve) => resolve(this._rates));
    // TODO: Errors
    return await this.http.get<ObjectResponse<any>>(environment.baseServerUrl + this.appConfig.urls.mortgage.base, { withCredentials: false })
      .pipe(map(res => {
        this._rates = res.result.map((r) => this._convertToRateCategory(r));
        return this._rates;
      }))
      .toPromise();
  }

  public calculateMortgagePayment(mortgageAmount: number, ratePercent: number,
    frequency: PaymentsFrequency = PaymentsFrequency.Weekly, yearCount: number = 25, amortizationPeriod?: number): number {
    // TODO: how does amortizationPeriod come into play
    const paymentsPerYear = this._getPaymentsPerYear(frequency);
    const pif = this._calculatePif(ratePercent, frequency, paymentsPerYear);
    const val = this._calculatePayment(mortgageAmount, frequency, yearCount, pif, paymentsPerYear, amortizationPeriod);
    return isNaN(val) ? 0 : val;
  }

  // TODO: What is this for
  public calculatePriceFromRate(rate: number, annualRatePercent: number, paymentFrequency: PaymentsFrequency.Weekly, amortizationPeriod: number): number {
    const pif = this._calculatePif(annualRatePercent, paymentFrequency, 0);
    return rate / (pif / (1 - (1.0 / Math.pow(pif + 1, amortizationPeriod))));
  }

  private _convertToRate(tmpRate): MortgageRate {
    const rate: MortgageRate = new MortgageRate();
    rate.term = tmpRate['@term'];
    rate.name = tmpRate.Name['#cdata-section'];
    rate.rate = tmpRate.Value['#cdata-section'];
    return rate;
  }

  // TODO: is there a way we can convert everything to array
  private _convertToRateSubCategory(tmpRateSub): MortgageRateSubCategory {
    const subCat: MortgageRateSubCategory = new MortgageRateSubCategory();
    subCat.name = tmpRateSub['@ID'];
    // In some cases where there is only one rate, its just a single object, not an array
    if (tmpRateSub.Rate.length) subCat.rates = tmpRateSub.Rate.filter(tmpR => tmpR.Value['#cdata-section'] !== '&nbsp;').map((tmpR) => this._convertToRate(tmpR));
    else subCat.rates = [this._convertToRate(tmpRateSub.Rate)];
    return subCat;
  }

  private _convertToRateCategory(tmpCat): MortageRateCategory {
    const rc: MortageRateCategory = new MortageRateCategory();
    const tmpRateCategory = tmpCat.RateCategory;
    rc.rateCategory = tmpRateCategory['@ID'];
    rc.subCategories = tmpRateCategory.RateSubCategory.map((tmpS) => this._convertToRateSubCategory(tmpS));
    return rc;
  }


  private _calculatePayment(mortgagePrice: number, frequency: PaymentsFrequency, yearCount: number, pif: number, paymentsPerYear: number, amortizationPeriod?: number) {
    switch (frequency) {
      case PaymentsFrequency.Default:
        return mortgagePrice * (pif / (1 - (1.0 / Math.pow(pif + 1, amortizationPeriod))));
      case PaymentsFrequency.RapidBiWeekly:
      case PaymentsFrequency.RapidWeekly:
        return ((mortgagePrice * (pif / (1 - (1.0 / Math.pow(pif + 1, 12 * yearCount))))) * 13) / paymentsPerYear;
      default:
        return mortgagePrice * (pif / (1 - (1.0 / Math.pow(pif + 1, paymentsPerYear * yearCount))));
    }
  }

  private _getPaymentsPerYear(frequency: PaymentsFrequency): number {
    switch (frequency) {
      // TODO: CONSTANTS WUT
      case PaymentsFrequency.BiWeekly:
      case PaymentsFrequency.RapidBiWeekly:
        return 365 / 14;
      case PaymentsFrequency.Weekly:
      case PaymentsFrequency.RapidWeekly:
        return 365 / 7;
      default:
        return 12;
    }
  }

  private _calculatePif(annualRatePercent: number, frequency: PaymentsFrequency, paymentsPerYear: number): number {
    switch (frequency) {
      case PaymentsFrequency.Default:
        return Math.pow(1 + annualRatePercent / 200, 1.0 / 6) - 1;
      case PaymentsFrequency.RapidBiWeekly:
      case PaymentsFrequency.RapidWeekly:
        // TODO: CONSTANTS
        return Math.pow(1 + annualRatePercent / 2, (2 / 12)) - 1;
      default:
        return Math.pow(1 + annualRatePercent / 2, (2 / paymentsPerYear)) - 1;
    }
  }
}
